import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-6 mt-3 py-3 border-bottom border-top bg-light space-y-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "col-12" }, "Upload domains", -1)
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = {
  type: "file",
  id: "file",
  ref: "file"
}
const _hoisted_5 = { class: "col-12" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", { class: "col-12" }, "Register a single domain", -1)
const _hoisted_7 = { class: "col-12" }
const _hoisted_8 = { class: "col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("label", _hoisted_3, [
        _createElementVNode("input", _hoisted_4, null, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submitFile()))
        }, " Submit ")
      ])
    ]),
    _createElementVNode("div", null, [
      _hoisted_6,
      _createElementVNode("label", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerDomainName) = $event)),
          class: "border"
        }, null, 512), [
          [_vModelText, _ctx.registerDomainName]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.registerDomain()))
        }, " Submit ")
      ])
    ])
  ]))
}